import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var BoldSvg = function BoldSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6 11.167V2h8.531c1.57 0 2.844 1.306 2.844 2.917V8.25c0 1.61-1.273 2.917-2.844 2.917zm0 0V22h10.156C17.726 22 19 20.694 19 19.083v-5c0-1.61-1.273-2.916-2.844-2.916z"
  }));
};
export var Bold = function Bold(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: BoldSvg
  }));
};